import React from 'react';

const TopbarBackground = ({ children }) => (
  <div style={{ height: 108, backgroundColor: 'rgb(69, 163, 247)' }}></div>
);

export default TopbarBackground;
